/**
 * Thrown when the bigQueryEndpoint's serverless platform rejects an oversized response before the
 * function's own error handling can run, leaving a failed response with a non-JSON body.
 */
export class ResponseTooLargeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ResponseTooLargeError';
  }
}
